import { Check, ChevronRight, ShieldCheck } from "lucide-react";
import type { AppContextOption } from "@/app/types";
import { AppSheet } from "@/shared/components/AppUi";

export function ContextSheet({ open, contexts, activeContextId, onClose, onChange }: {
  open: boolean; contexts: AppContextOption[]; activeContextId: string; onClose: () => void; onChange: (id: string) => void;
}) {
  return <AppSheet open={open} title="Trocar contexto" kicker="Experiência ativa" onClose={onClose}>
    <p className="-mt-1 text-sm leading-5 text-white/55">Escolha a academia e como você está usando o YamarHub agora.</p>
    <div className="mt-5 space-y-2">
      {contexts.map((context) => {
        const active = context.id === activeContextId;
        return <button type="button" key={context.id} aria-current={active?"true":undefined} onClick={() => { onChange(context.id); onClose(); }} className={`flex min-h-16 w-full items-center gap-3 rounded-2xl border p-4 text-left transition active:scale-[.99] ${active ? "border-teal/50 bg-teal/15" : "border-white/10 bg-[#0A1112]"}`}>
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal/10 text-teal"><ShieldCheck className="h-5 w-5" /></div>
          <div className="min-w-0 flex-1"><p className="truncate font-medium text-white">{context.tenantName}</p><p className="text-sm text-white/55">{context.label}</p></div>
          {active ? <Check className="h-5 w-5 text-teal" /> : <ChevronRight className="h-5 w-5 text-white/30" />}
        </button>;
      })}
    </div>
  </AppSheet>;
}
